<template>
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    height="100%"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <path
          d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,448c-105.865,0-192-86.135-192-192c0-40.406,12.25-78.604,35.542-111.198l267.656,267.656C334.604,435.75,296.406,448,256,448zM412.458,367.198L144.802,99.542C177.396,76.25,215.594,64,256,64c105.865,0,192,86.135,192,192C448,296.406,435.75,334.604,412.458,367.198z"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4StopFreeSvg"
};
</script>
